export enum OperatorType {
  EQUAL = '=',
  DIFFERENT = '<>'
}
